export const zIndex = {
  default: 1,
  overlay: 800,
  modal: 825,
} as const;
